import type { ShowMoreProps } from 'react-big-calendar'
import React from 'react'
import { makeStyles, useDialogs, Typography } from '@paintscout/ui'
import type { CalendarEvent } from 'paintscout'
import classnames from 'classnames'
import { useCalendar } from '../CalendarContext'
import { ViewEventsDialog } from '../../../dialogs'

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: 'pointer',
    fontSize: theme.typography.pxToRem(11),
    marginLeft: theme.spacing(1),
    zIndex: 1000,
    position: 'relative',
    backgroundColor: 'transparent'
  }
}))

export default function ShowMore(props: ShowMoreProps<CalendarEvent>) {
  const { count, events } = props
  const classes = useStyles()
  const { addEvent, updateEvent, deleteEvent, selectedUsers } = useCalendar()
  const { openDialog } = useDialogs()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    openDialog(ViewEventsDialog, {
      events,
      addEvent,
      updateEvent,
      deleteEvent,
      groupByEstimator: true,
      selectedUsers
    })
  }
  return (
    <Typography
      variant="subtitle2"
      color="textPrimary"
      className={classnames(classes.root, 'rbc-button-link rbc-show-more')}
      onClick={handleClick}
      component="div"
    >
      {count} more...
    </Typography>
  )
}
